import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import { keyString2x2ocg778b9mu as keyString } from '../keyValue.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from '../nav/crowpay.mjs';
import { withSpacing5keoy85vrpk as withSpacing } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  renderAttachmentImage20glz1emw24de as renderAttachmentImage,
  LocalFileyitm5ua4ch17 as LocalFile,
  Empty276q86o7r56ey as Empty,
  RemoteAttachment3uyi4s0lht7h0 as RemoteAttachment,
  Empty_instance19pnqi35t6rfs as Empty_instance,
} from './attachmentFilePreview.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  timesx4ey3un7ihw1 as times,
  Dimension__compareTo_impl_gsceod2qehgbisv77nv as Dimension__compareTo_impl_gsceod,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { align1ejncrrer3meh as align } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
} from '../../theming/buttons.mjs';
import { get_edit2tiiawv2658bs as get_edit } from '../../../icons.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  plus2opbwe063z9pg as plus,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  lazygopf2ohairjp as lazy,
} from '../../../utils/utils.mjs';
import {
  icon1sxjaie5w1apt as icon,
  errorTextv58wi1t0me7u as errorText,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  title1ahgushtajx2d as title,
  bodyBold2czwdzwknab0k as bodyBold,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  chunked1umgsyuj0x9u1 as chunked,
  plus310ted5e4i90h as plus_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  requestFile18ia1vr614wjr as requestFile,
  ExternalServices_instancen7y3lfkh3gae as ExternalServices_instance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { mimeType31eog9gy5012s as mimeType } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { License2dabzwgw7jcr2 as License } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_number12xa0a80pfu1s as get_number,
  get_city1bjg5zekkdtgv as get_city,
  get_state1oz04fp2krbaq as get_state,
  get_type2gglctwv6p9gt as get_type,
  get_file34qr2ah8a6n2l as get_file,
  get_preview30bi6nssrxjqo as get_preview,
  get_fileTypeygrn13ooccjs as get_fileType,
} from '../../../../../../crowpay-shared/com/crowpay/LicenseFields.mjs';
import { Chainlkbkk6tcx8wg as Chain } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Modification.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import {
  LicenseType_Business_getInstance28mtgpzgwrkl8 as LicenseType_Business_getInstance,
  get_entries2mo1k9tr8oys as get_entries,
  get_entriesyts36b0as1vz as get_entries_0,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import {
  assertNotBlankk8x8axj5z9hq as assertNotBlank,
  assertNotNull3tylj1kgh6bbg as assertNotNull,
  validateReactive3qltvv4cs75dh as validateReactive,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { validategsg6go7eyi9d as validate } from '../../../utils/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { nullToBlank26aqgq3jx9stc as nullToBlank } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { renderFilePreview3fl8uuiu4tdzl as renderFilePreview } from './renderFiles.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { ImagePreview2jehuxn8wua45 as ImagePreview } from '../../dialogs/ImagePreview.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../selectedContractor.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_px1lajc6xaddk2r as get_px } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.js.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../theming/sections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderLicense(_this__u8e3s4, license) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.eba(get_AppDimensions().xg1_1);
  view.zb8(get_AppDimensions().xg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  keyString(view_0, 'Type', license.e6f_1.a4_1);
  keyString(view_0, 'Number', license.y6e_1);
  keyString(view_0, 'Region', !(license.z6e_1 == null) ? '' + license.z6e_1 + ', ' + license.a6f_1.f9b_1 : license.a6f_1.e9b_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  view_1.xbm(get_viewIsWide(view_1));
  var tmp = view_1.ibb(withSpacing(view_1, 0.0), sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().qg2_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  renderAttachmentImage(view_2, license);
  onClick(view_2, VOID, VOID, renderLicense$slambda_0(license));
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp, view_2);
  var tmp_0 = view_1.ibb(align(view_1, Align_End_getInstance(), Align_Center_getInstance()), get_tertiaryButton(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.ebb(p_3, view_3);
  icon(view_3, resize(get_edit(Companion_getInstance()), get_rem(1.5)), 'Edit License');
  onClick(view_3, VOID, VOID, renderLicense$slambda_2(license));
  view_1.fbb(p_3, view_3);
  view_1.jbb(tmp_0, view_3);
  view_0.fbb(p_1, view_1);
  view.fbb(p_0, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderLicenses(_this__u8e3s4, licences, type) {
  type = type === VOID ? null : type;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
  view_0.hb7(false);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_shown_$ref_kipsub(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, TextView$_set_shown_$ref_l7jsq9(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.baj(licences).i1();
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_0.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'No Licenses uploaded';
  var tmp_1 = view_0.tb5_1;
  var tmp_2;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_2 = '\xA0';
  } else {
    tmp_2 = value;
  }
  tmp_1.fbu(tmp_2);
  view.fbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.xbm(true);
  var tmp_3 = KMutableProperty0();
  var tmp_4 = RowOrCol$_get_shown_$ref_m8lfse(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('shown', 0, tmp_3, tmp_4, RowOrCol$_set_shown_$ref_7290m6(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$10 = !$this$reactiveScope.baj(licences).i1();
    this_1.set(tmp$ret$10);
    return Unit_instance;
  });
  var tmp_5;
  if (get_viewIsNarrow(view_1)) {
    tmp_5 = new (Constant())(_Constant___init__impl__v45mub(1));
  } else {
    tmp_5 = remember(VOID, VOID, VOID, renderLicenses$lambda);
  }
  var count = tmp_5;
  var chunked_0 = remember(VOID, VOID, VOID, ($this$remember) => chunked($this$remember.baj(licences), $this$remember.baj(count)));
  forEachUpdating(view_1, chunked_0, 1, renderLicenses$lambda_0);
  view.fbb(p_1, view_1);
  var tmp_6 = view.ibb(align(view, Align_End_getInstance(), Align_Center_getInstance()), get_tertiaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view.pc());
  var tmp0_elvis_lhs_2 = view.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.ebb(p_2, view_2);
  icon(view_2, Companion_getInstance().wcf_1, 'Add License');
  onClick(view_2, VOID, VOID, renderLicenses$slambda_0(type));
  view.fbb(p_2, view_2);
  view.jbb(tmp_6, view_2);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'kotlin.also' call
  var this_0 = new (LocalFile())($this.bgd_1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp = await_0(this_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = this_0.xgb(LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().mff_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.agd_1.gah(this_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.cgd_1 = p0;
      }
      sao($completion) {
        return this.cgd_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2ContractorLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = requestFile($this.dgd_1.pc(), listOf(['image/*', 'application/pdf']), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    launch($this.dgd_1, VOID, VOID, LicenseFormDialog$render$slambda$slambda_0($this.egd_1, tmp0_safe_receiver));
  }
  return Unit_instance;
}
var LicenseFormDialog$render$slambda$slambdaClass;
function LicenseFormDialog$render$slambda$slambda() {
  if (LicenseFormDialog$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor($licenseImage, $it) {
        this.agd_1 = $licenseImage;
        this.bgd_1 = $it;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LicenseFormDialog$render$slambda$slambdaClass = $;
  }
  return LicenseFormDialog$render$slambda$slambdaClass;
}
function LicenseFormDialog$render$slambda$slambda_0($licenseImage, $it) {
  var i = new (LicenseFormDialog$render$slambda$slambda())($licenseImage, $it);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.lfv_1.eeo($this.igd_1.ggd_1.w6e_1).iem($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  get_dialogStack().ngd();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ogd_1.pat_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    $this.pgd_1.mam(true);
    return Unit_instance;
  } else {
    $this.pgd_1.mam(false);
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.qgd_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var image = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.rgd_1;
  var tmp_1 = await_1(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_elvis_lhs = tmp_1;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  var state = tmp_2;
  if (!($this.sgd_1.ggd_1 == null)) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_3 = ArrayList().w();
    var tmp_3 = awaitOnce($this.tgd_1, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    if (!($this.sgd_1.ggd_1.y6e_1 === tmp_3)) {
      // Inline function 'com.lightningkite.lightningdb.modification' call
      // Inline function 'kotlin.apply' call
      var this_4 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_4 = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
      var tmp$ret$4 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
      var it = new (DataClassPathSelf())(tmp$ret$4);
      var tmp_5 = get_number(it);
      var tmp_6 = awaitOnce($this.tgd_1, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      this_4.e44(tmp_5, tmp_6);
      var tmp$ret$9 = this_4.o1r();
      this_3.v(tmp$ret$9);
    }
    var tmp_7 = awaitOnce($this.ugd_1, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    if (!($this.sgd_1.ggd_1.z6e_1 == tmp_7)) {
      // Inline function 'com.lightningkite.lightningdb.modification' call
      // Inline function 'kotlin.apply' call
      var this_5 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_8 = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
      var tmp$ret$10 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
      var it_0 = new (DataClassPathSelf())(tmp$ret$10);
      var tmp_9 = get_city(it_0);
      var tmp_10 = awaitOnce($this.ugd_1, $completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
      this_5.e44(tmp_9, tmp_10);
      var tmp$ret$15 = this_5.o1r();
      this_3.v(tmp$ret$15);
    }
    if (!$this.sgd_1.ggd_1.a6f_1.equals(state)) {
      // Inline function 'com.lightningkite.lightningdb.modification' call
      // Inline function 'kotlin.apply' call
      var this_6 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_11 = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
      var tmp$ret$16 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
      var it_1 = new (DataClassPathSelf())(tmp$ret$16);
      this_6.e44(get_state(it_1), state);
      var tmp$ret$21 = this_6.o1r();
      this_3.v(tmp$ret$21);
    }
    if (!$this.sgd_1.ggd_1.e6f_1.equals($this.vgd_1.f2())) {
      // Inline function 'com.lightningkite.lightningdb.modification' call
      // Inline function 'kotlin.apply' call
      var this_7 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_12 = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
      var tmp$ret$22 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
      var it_2 = new (DataClassPathSelf())(tmp$ret$22);
      this_7.e44(get_type(it_2), $this.vgd_1.f2());
      var tmp$ret$27 = this_7.o1r();
      this_3.v(tmp$ret$27);
    }
    if ((image instanceof LocalFile() ? image : null) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.lightningdb.modification' call
      // Inline function 'kotlin.apply' call
      var this_8 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_13 = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
      var tmp$ret$28 = isInterface(tmp_13, KSerializer()) ? tmp_13 : THROW_CCE();
      var it_3 = new (DataClassPathSelf())(tmp$ret$28);
      var tmp_14 = get_file(it_3);
      var tmp_15 = image.kgb_1;
      this_8.e44(tmp_14, ensureNotNull(tmp_15 == null ? null : new (ServerFile())(tmp_15)));
      var tmp$ret$33 = this_8.o1r();
      this_3.v(tmp$ret$33);
      // Inline function 'com.lightningkite.lightningdb.modification' call
      // Inline function 'kotlin.apply' call
      var this_9 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_16 = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
      var tmp$ret$34 = isInterface(tmp_16, KSerializer()) ? tmp_16 : THROW_CCE();
      var it_4 = new (DataClassPathSelf())(tmp$ret$34);
      var tmp_17 = get_preview(it_4);
      var tmp_18 = image.lgb_1;
      this_9.e44(tmp_17, tmp_18 == null ? null : new (ServerFile())(tmp_18));
      var tmp$ret$39 = this_9.o1r();
      this_3.v(tmp$ret$39);
      // Inline function 'com.lightningkite.lightningdb.modification' call
      // Inline function 'kotlin.apply' call
      var this_10 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_19 = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
      var tmp$ret$40 = isInterface(tmp_19, KSerializer()) ? tmp_19 : THROW_CCE();
      var it_5 = new (DataClassPathSelf())(tmp$ret$40);
      this_10.e44(get_fileType(it_5), mimeType(image.igb_1));
      var tmp$ret$45 = this_10.o1r();
      this_3.v(tmp$ret$45);
    }
    var tmp$ret$51 = this_3.c8();
    var mods = Chain().j42(tmp$ret$51);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!mods.i42_1.i1()) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_11 = get_session();
      var tmp_20 = await_0(this_11, $completion);
      if (tmp_20 === get_COROUTINE_SUSPENDED())
        tmp_20 = yield tmp_20;
      var tmp_21 = tmp_20.lfv_1.eeo($this.sgd_1.ggd_1.w6e_1).len(mods, $completion);
      if (tmp_21 === get_COROUTINE_SUSPENDED())
        tmp_21 = yield tmp_21;
    }
  } else {
    var i = image instanceof LocalFile() ? image : THROW_CCE();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_12 = get_session();
    var tmp_22 = await_0(this_12, $completion);
    if (tmp_22 === get_COROUTINE_SUSPENDED())
      tmp_22 = yield tmp_22;
    var tmp_23 = tmp_22.lfv_1;
    var tmp1_contractor = $this.sgd_1.fgd_1;
    var tmp_24 = awaitOnce($this.tgd_1, $completion);
    if (tmp_24 === get_COROUTINE_SUSPENDED())
      tmp_24 = yield tmp_24;
    var tmp2_number = tmp_24;
    var tmp_25 = awaitOnce($this.ugd_1, $completion);
    if (tmp_25 === get_COROUTINE_SUSPENDED())
      tmp_25 = yield tmp_25;
    var tmp3_city = tmp_25;
    var tmp4_type = $this.vgd_1.f2();
    var tmp_26 = i.kgb_1;
    var tmp5_file = ensureNotNull(tmp_26 == null ? null : new (ServerFile())(tmp_26)).n2n_1;
    var tmp6_preview = i.lgb_1;
    var tmp7_fileType = mimeType(i.igb_1);
    var tmp_27 = tmp_23.zen(new (License())(VOID, tmp1_contractor, tmp2_number, tmp3_city, state, tmp5_file, tmp7_fileType, tmp6_preview, tmp4_type), $completion);
    if (tmp_27 === get_COROUTINE_SUSPENDED())
      tmp_27 = yield tmp_27;
  }
  get_dialogStack().ngd();
  return Unit_instance;
}
var LicenseFormDialog$render$slambdaClass;
function LicenseFormDialog$render$slambda() {
  if (LicenseFormDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LicenseFormDialog$render$slambdaClass = $;
  }
  return LicenseFormDialog$render$slambdaClass;
}
function LicenseFormDialog$render$slambda_0() {
  var i = new (LicenseFormDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function LicenseFormDialog$render$lambda($this$validateReactive, it) {
  var tmp;
  if (it instanceof Empty()) {
    tmp = 'You must upload an image of the license';
  } else {
    var tmp_0;
    if (it instanceof LocalFile()) {
      tmp_0 = !($this$validateReactive.baj($this$validateReactive.baj(it.vgb())) === true);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = 'Your image failed to upload. Please try again';
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function LicenseFormDialog$render$lambda_0(it) {
  return it.a4_1;
}
function LicenseFormDialog$render$lambda_1(it) {
  var tmp1_elvis_lhs = it == null ? null : it.e9b_1;
  return tmp1_elvis_lhs == null ? 'Unselected' : tmp1_elvis_lhs;
}
var LicenseFormDialog$render$slambdaClass_0;
function LicenseFormDialog$render$slambda_1() {
  if (LicenseFormDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, $licenseImage) {
        this.dgd_1 = $$this$button;
        this.egd_1 = $licenseImage;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LicenseFormDialog$render$slambdaClass_0 = $;
  }
  return LicenseFormDialog$render$slambdaClass_0;
}
function LicenseFormDialog$render$slambda_2($$this$button, $licenseImage) {
  var i = new (LicenseFormDialog$render$slambda_1())($$this$button, $licenseImage);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LicenseFormDialog$render$slambdaClass_1;
function LicenseFormDialog$render$slambda_3() {
  if (LicenseFormDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.igd_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LicenseFormDialog$render$slambdaClass_1 = $;
  }
  return LicenseFormDialog$render$slambdaClass_1;
}
function LicenseFormDialog$render$slambda_4(this$0) {
  var i = new (LicenseFormDialog$render$slambda_3())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LicenseFormDialog$render$slambdaClass_2;
function LicenseFormDialog$render$slambda_5() {
  if (LicenseFormDialog$render$slambdaClass_2 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LicenseFormDialog$render$slambdaClass_2 = $;
  }
  return LicenseFormDialog$render$slambdaClass_2;
}
function LicenseFormDialog$render$slambda_6() {
  var i = new (LicenseFormDialog$render$slambda_5())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LicenseFormDialog$render$slambdaClass_3;
function LicenseFormDialog$render$slambda_7() {
  if (LicenseFormDialog$render$slambdaClass_3 === VOID) {
    class $ {
      constructor($node, $submitFailed, $licenseImage, $state, this$0, $number, $city, $type) {
        this.ogd_1 = $node;
        this.pgd_1 = $submitFailed;
        this.qgd_1 = $licenseImage;
        this.rgd_1 = $state;
        this.sgd_1 = this$0;
        this.tgd_1 = $number;
        this.ugd_1 = $city;
        this.vgd_1 = $type;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LicenseFormDialog$render$slambdaClass_3 = $;
  }
  return LicenseFormDialog$render$slambdaClass_3;
}
function LicenseFormDialog$render$slambda_8($node, $submitFailed, $licenseImage, $state, this$0, $number, $city, $type) {
  var i = new (LicenseFormDialog$render$slambda_7())($node, $submitFailed, $licenseImage, $state, this$0, $number, $city, $type);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LicenseFormDialogClass;
function LicenseFormDialog() {
  if (LicenseFormDialogClass === VOID) {
    class $ {
      constructor(contractorId, license, licenseType) {
        this.fgd_1 = contractorId;
        this.ggd_1 = license;
        this.hgd_1 = licenseType;
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(LicenseFormDialog$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        var tmp = view.ibb(view.ibb(view.hbb(DialogSemantic_getInstance()), get_scrolling(view)), get_centered(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        var tmp_0 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, times(get_AppDimensions().eg2_1, 0.85));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        title(view_1, ($this$title) => {
          var tmp = this.ggd_1 == null ? 'New' : 'Edit';
          var tmp0_safe_receiver = this.hgd_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a4_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver + ' ';
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = tmp + ' ' + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs) + 'License';
          var tmp_0 = $this$title.tb5_1;
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_1 = '\xA0';
          } else {
            tmp_1 = value;
          }
          tmp_0.fbu(tmp_1);
          return Unit_instance;
        });
        var node = new (IssueNode())(null);
        var submitFailed = Signal().fak(false);
        var tmp0_safe_receiver = this.ggd_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e6f_1;
        var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this.hgd_1 : tmp1_elvis_lhs;
        var type = Signal().fak(tmp2_elvis_lhs == null ? LicenseType_Business_getInstance() : tmp2_elvis_lhs);
        var tmp3_safe_receiver = this.ggd_1;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.y6e_1;
        var number = assertNotBlank(validated(Signal().fak(tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs), node), 'License Number cannot be blank');
        var tmp5_safe_receiver = this.ggd_1;
        var city = Signal().fak(tmp5_safe_receiver == null ? null : tmp5_safe_receiver.z6e_1);
        var tmp6_safe_receiver = this.ggd_1;
        var state = assertNotNull(validated(Signal().fak(tmp6_safe_receiver == null ? null : tmp6_safe_receiver.a6f_1), node));
        var tmp7_safe_receiver = this.ggd_1;
        var tmp_1;
        if (tmp7_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = new (RemoteAttachment())(tmp7_safe_receiver);
        }
        var tmp8_elvis_lhs = tmp_1;
        var licenseImage = validated(Signal().fak(tmp8_elvis_lhs == null ? Empty_instance : tmp8_elvis_lhs), node);
        validateReactive(licenseImage, LicenseFormDialog$render$lambda);
        if (!(this.hgd_1 == null)) {
          // Inline function 'com.crowpay.views.components.requiredField' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.ebb(p_2, view_2);
          view_2.xbm(true);
          view_2.zb8(get_AppDimensions().ng2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RowOrCol())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.ebb(p_3, view_3);
          view_3.xbm(false);
          view_3.zb8(get_AppDimensions().pg2_1);
          view_3.jbb(get_centered(view_3), bodyBold(view_3, 'Type'));
          view_3.jbb(colored(view_3, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_3, '*'));
          view_2.fbb(p_3, view_3);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_2 = view_2.hbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (Select())(view_2.pc());
          var tmp0_elvis_lhs_4 = view_2.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
          view_2.ebb(p_4, view_4);
          var tmp_3 = _Constant___init__impl__v45mub(get_entries());
          view_4.mcf(type, new (Constant())(tmp_3), LicenseFormDialog$render$lambda_0);
          view_2.fbb(p_4, view_4);
          view_2.jbb(tmp_2, view_4);
          view_1.fbb(p_2, view_2);
        }
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_5 = view_1.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
        view_1.ebb(p_5, view_5);
        view_5.xbm(true);
        view_5.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_6.xbm(false);
        view_6.zb8(get_AppDimensions().pg2_1);
        view_6.jbb(get_centered(view_6), bodyBold(view_6, 'Number'));
        view_6.jbb(colored(view_6, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_6, '*'));
        view_5.fbb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_4 = view_5.hbb(FieldSemantic_getInstance());
        var tmp_5 = validate(view_5, number, ($this$validate) => $this$validate.baj(submitFailed));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextInput())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.ebb(p_7, view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = 'License Number';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_7.tb5_1.zb3_1.ib7_1.placeholder = value;
        view_7.xah(view_7.gcn_1, number);
        view_5.fbb(p_7, view_7);
        view_5.jbb(tmp_5, view_7);
        var tmp_6 = get_issues(number);
        var tmp$ret$28 = issueText(view_5, tmp_6, VOID, ($this$issueText) => $this$issueText.baj(submitFailed));
        view_5.jbb(tmp_4, tmp$ret$28);
        view_1.fbb(p_5, view_5);
        // Inline function 'com.crowpay.views.components.field2' call
        var label = 'City (Optional)';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_8 = view_1.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
        view_1.ebb(p_8, view_8);
        view_8.xbm(true);
        view_8.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_8, label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_7 = view_8.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (TextInput())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.ebb(p_9, view_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_9.tb5_1.zb3_1.ib7_1.placeholder = 'City';
        view_9.xah(view_9.gcn_1, nullToBlank(city));
        view_8.fbb(p_9, view_9);
        view_8.jbb(tmp_7, view_9);
        view_8.jbb(view_8.hbb(SubtextSemantic_getInstance()), errorText(view_8));
        view_1.fbb(p_8, view_8);
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_10 = view_1.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_1 : tmp0_elvis_lhs_10;
        view_1.ebb(p_10, view_10);
        view_10.xbm(true);
        view_10.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_11 = view_10.cbb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
        view_10.ebb(p_11, view_11);
        view_11.xbm(false);
        view_11.zb8(get_AppDimensions().pg2_1);
        view_11.jbb(get_centered(view_11), bodyBold(view_11, 'State'));
        view_11.jbb(colored(view_11, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_11, '*'));
        view_10.fbb(p_11, view_11);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_8 = view_10.hbb(FieldSemantic_getInstance());
        var tmp_9 = validate(view_10, state, ($this$validate) => $this$validate.baj(submitFailed));
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (Select())(view_10.pc());
        var tmp0_elvis_lhs_12 = view_10.cbb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
        view_10.ebb(p_12, view_12);
        var tmp_10 = _Constant___init__impl__v45mub(plus_0(listOf_0(null), get_entries_0()));
        view_12.mcf(state, new (Constant())(tmp_10), LicenseFormDialog$render$lambda_1);
        view_10.fbb(p_12, view_12);
        view_10.jbb(tmp_9, view_12);
        var tmp_11 = get_issues(state);
        var tmp$ret$54 = issueText(view_10, tmp_11, VOID, ($this$issueText) => $this$issueText.baj(submitFailed));
        view_10.jbb(tmp_8, tmp$ret$54);
        view_1.fbb(p_10, view_10);
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_13 = view_1.cbb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_1 : tmp0_elvis_lhs_13;
        view_1.ebb(p_13, view_13);
        view_13.xbm(true);
        view_13.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (RowOrCol())(view_13.pc());
        var tmp0_elvis_lhs_14 = view_13.cbb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
        view_13.ebb(p_14, view_14);
        view_14.xbm(false);
        view_14.zb8(get_AppDimensions().pg2_1);
        view_14.jbb(get_centered(view_14), bodyBold(view_14, 'Image'));
        view_14.jbb(colored(view_14, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_14, '*'));
        view_13.fbb(p_14, view_14);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_12 = view_13.hbb(FieldSemantic_getInstance());
        var tmp_13 = sizeConstraints(view_13, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().rg2_1, get_AppDimensions().rg2_1);
        var tmp_14 = view_13.ibb(view_13.ibb(tmp_13, validate(view_13, licenseImage, ($this$validate) => $this$validate.baj(submitFailed))), get_unpadded(view_13));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (Button())(view_13.pc());
        var tmp0_elvis_lhs_15 = view_13.cbb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_13 : tmp0_elvis_lhs_15;
        view_13.ebb(p_15, view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (Frame())(view_15.pc());
        var tmp0_elvis_lhs_16 = view_15.cbb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
        view_15.ebb(p_16, view_16);
        lazy(view_16, licenseImage, ($this$lazy, filePreview) => {
          renderFilePreview($this$lazy, filePreview, get_AppDimensions().rg2_1);
          var tmp = get_centered($this$lazy);
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$lazy.pc());
          var tmp0_elvis_lhs = $this$lazy.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$lazy : tmp0_elvis_lhs;
          $this$lazy.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          view.bbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = 'Image\nSource';
          var tmp_0 = view.tb5_1;
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_1 = '\xA0';
          } else {
            tmp_1 = value;
          }
          tmp_0.fbu(tmp_1);
          shownDefaultFalse(view, ($this$shownDefaultFalse) => equals($this$shownDefaultFalse.baj(licenseImage), Empty_instance));
          $this$lazy.fbb(p, view);
          $this$lazy.jbb(tmp, view);
          return Unit_instance;
        });
        view_15.fbb(p_16, view_16);
        onClick(view_15, VOID, VOID, LicenseFormDialog$render$slambda_2(view_15, licenseImage));
        view_13.fbb(p_15, view_15);
        view_13.jbb(tmp_14, view_15);
        var tmp_15 = get_issues(licenseImage);
        var tmp$ret$81 = issueText(view_13, tmp_15, VOID, ($this$issueText) => {
          var tmp;
          if ($this$issueText.baj(submitFailed)) {
            tmp = true;
          } else {
            // Inline function 'kotlin.collections.map' call
            var this_0 = $this$issueText.baj(get_issues(licenseImage));
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.m1();
            while (_iterator__ex2g4s.n1()) {
              var item = _iterator__ex2g4s.o1();
              var tmp$ret$78 = item.iat();
              destination.v(tmp$ret$78);
            }
            tmp = destination.t1('Your image failed to upload. Please try again');
          }
          return tmp;
        });
        view_13.jbb(tmp_12, tmp$ret$81);
        view_1.fbb(p_13, view_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_17 = view_1.cbb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_1 : tmp0_elvis_lhs_17;
        view_1.ebb(p_17, view_17);
        view_17.xbm(false);
        if (!(this.ggd_1 == null)) {
          var tmp_16 = get_deleteButton(view_17);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_18 = new (Button())(view_17.pc());
          var tmp0_elvis_lhs_18 = view_17.cbb_1;
          var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
          view_17.ebb(p_18, view_18);
          if (get_viewIsWide(view_18))
            specCenteredText(view_18, 'Delete');
          else
            body(view_18, 'Delete');
          onClick(view_18, VOID, VOID, LicenseFormDialog$render$slambda_4(this));
          view_17.fbb(p_18, view_18);
          view_17.jbb(tmp_16, view_18);
        }
        var tmp_17 = get_expanding(view_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_19 = new (Space())(view_17.pc());
        var tmp0_elvis_lhs_19 = view_17.cbb_1;
        var p_19 = tmp0_elvis_lhs_19 == null ? view_17 : tmp0_elvis_lhs_19;
        view_17.ebb(p_19, view_19);
        view_17.fbb(p_19, view_19);
        view_17.jbb(tmp_17, view_19);
        var tmp_18 = get_secondaryButton(view_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_20 = new (Button())(view_17.pc());
        var tmp0_elvis_lhs_20 = view_17.cbb_1;
        var p_20 = tmp0_elvis_lhs_20 == null ? view_17 : tmp0_elvis_lhs_20;
        view_17.ebb(p_20, view_20);
        specCenteredText(view_20, 'Cancel');
        onClick(view_20, VOID, VOID, LicenseFormDialog$render$slambda_6());
        view_17.fbb(p_20, view_20);
        view_17.jbb(tmp_18, view_20);
        var tmp_19 = get_primaryButton(view_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_21 = new (Button())(view_17.pc());
        var tmp0_elvis_lhs_21 = view_17.cbb_1;
        var p_21 = tmp0_elvis_lhs_21 == null ? view_17 : tmp0_elvis_lhs_21;
        view_17.ebb(p_21, view_21);
        specCenteredText(view_21, 'Save');
        onClick(view_21, VOID, VOID, LicenseFormDialog$render$slambda_8(node, submitFailed, licenseImage, state, this, number, city, type));
        view_17.fbb(p_21, view_21);
        view_17.jbb(tmp_19, view_21);
        view_1.fbb(p_17, view_17);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'LicenseFormDialog', VOID, VOID, [Page()]);
    LicenseFormDialogClass = $;
  }
  return LicenseFormDialogClass;
}
var renderLicense$slambdaClass;
function renderLicense$slambda() {
  if (renderLicense$slambdaClass === VOID) {
    class $ {
      constructor($license) {
        this.wgd_1 = $license;
      }
      sao($completion) {
        if (startsWith(this.wgd_1.c6f_1, 'image')) {
          get_dialogStack().xgd(new (ImagePreview())(listOf_0(this.wgd_1)));
        } else {
          ExternalServices_instance.scu(_ServerFile___get_location__impl__ddyqaq(this.wgd_1.b6f_1));
        }
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderLicense$slambdaClass = $;
  }
  return renderLicense$slambdaClass;
}
function renderLicense$slambda_0($license) {
  var i = new (renderLicense$slambda())($license);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_notNullContractor();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.xgd(new (LicenseFormDialog())(tmp$ret$0, $this.ygd_1, null));
  return Unit_instance;
}
var renderLicense$slambdaClass_0;
function renderLicense$slambda_1() {
  if (renderLicense$slambdaClass_0 === VOID) {
    class $ {
      constructor($license) {
        this.ygd_1 = $license;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderLicense$slambdaClass_0 = $;
  }
  return renderLicense$slambdaClass_0;
}
function renderLicense$slambda_2($license) {
  var i = new (renderLicense$slambda_1())($license);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.wb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function renderLicenses$lambda($this$remember) {
  var window_0 = $this$remember.baj(AppState_getInstance().mbi());
  var raw = get_px(get_AppDimensions().qg2_1);
  var tmp;
  if (Dimension__compareTo_impl_gsceod(window_0.ebi_1, plus(get_AppDimensions().eg2_1, get_AppDimensions().sg2_1)) > 0) {
    tmp = get_px(get_AppDimensions().eg2_1) / raw;
  } else {
    tmp = get_px(window_0.ebi_1) / raw;
  }
  return numberToInt(tmp) - 1 | 0;
}
function renderLicenses$lambda_0($this$forEachUpdating, chunk) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$forEachUpdating.pc());
  var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
  $this$forEachUpdating.ebb(p, view);
  view.xbm(false);
  forEach(view, chunk, renderLicenses$lambda$lambda);
  $this$forEachUpdating.fbb(p, view);
  return Unit_instance;
}
function renderLicenses$lambda$lambda($this$forEach, it) {
  var tmp = get_expanding($this$forEach);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())($this$forEach.pc());
  var tmp0_elvis_lhs = $this$forEach.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
  $this$forEach.ebb(p, view);
  view.jbb(view.ibb(get_centered(view), get_lightSection(view)), renderLicense(view, it));
  $this$forEach.fbb(p, view);
  $this$forEach.jbb(tmp, view);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_notNullContractor();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.xgd(new (LicenseFormDialog())(tmp$ret$0, null, $this.zgd_1));
  return Unit_instance;
}
var renderLicenses$slambdaClass;
function renderLicenses$slambda() {
  if (renderLicenses$slambdaClass === VOID) {
    class $ {
      constructor($type) {
        this.zgd_1 = $type;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderLicenses$slambdaClass = $;
  }
  return renderLicenses$slambdaClass;
}
function renderLicenses$slambda_0($type) {
  var i = new (renderLicenses$slambda())($type);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  renderLicenses as renderLicenses2e5bww0s916bf,
};
//endregion

//# sourceMappingURL=contractorLicences.mjs.map
